import dayjs from "../../../utility/dayjs";
import Utils from "../../../utility";

const initialState = {
  cashPendingReport: [],
  formDate: dayjs(),
  toDate: dayjs(),
  storeId: "",
  warehouseId: "",
  cashoutReport: [],
  cashinReport: [],
};
export const reportReducer = (state = initialState, action) => {
  switch (action.type) {
    case `${Utils.ActionName.STORE_AND_WAREHOUSE_REPORTS}`:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return { ...state };
  }
};
